import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=b449a3d2"
import script from "./menus.js?vue&type=script&lang=js&external"
export * from "./menus.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports